(function () {
  'use strict';

  class ProductivityReportCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state, moment, $stateParams) {
      this.keys = Keys;
      this.moment = moment;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;
      this.stateParams = $stateParams;

      this.filtro = null;
      this.user = null;
      this.tabIndex = this.getValidatedTabIndex();

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([
          {
            name: 'uoId',
            key: this.keys.uo.name
          },
          {
            key: this.keys.dateTime.name,
            time: true,
            maxDate: this.moment().endOf('day').format(),
            defaultValues: {
              hoje: {
                active: true
              },
              ontem: {
                active: true
              }
            }
          },
          {
            name: 'veiculosId',
            key: this.keys.veiculos.name,
            ignoreValidation: true
          }
        ])
      ).then((filtro) => {
        this.filtro = filtro;
      });
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
        componentName = './ProductivityReportPageRoute',
        componentId = 'safety-productivity-report',
        props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    getValidatedTabIndex() {
      const tabIndex = Number(this.stateParams.tabIndex);

      if (tabIndex === 0 || tabIndex === 1 || tabIndex === 2) {
        return tabIndex;
      }

      return 0;
    }

    getReactProps() {
      const filteredVehicles = this.filtro.find((f) => f.key === this.keys.veiculos.name);

      return {
        user: this.user,
        filter: {
          ouId: this.filtro.find((f) => f.key === this.keys.uo.name).value.id,
          startDate: this.filtro.find((f) => f.key === this.keys.dateTime.name).value.startDate,
          endDate: this.filtro.find((f) => f.key === this.keys.dateTime.name).value.endDate,
          vehicleIds: filteredVehicles ? filteredVehicles.values.map((v) => v.id) : []
        },
        tabIndex: this.tabIndex
      };
    }

  }

  angular
    .module('productivity-report')
    .controller('ProductivityReportCtrl', ProductivityReportCtrl);
}());
